module.exports = __webpack_public_path__ + "static/img/right.0b06ed36.png";